// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
// biome-ignore lint/style/useImportType: <explanation>
import React from 'react';
import { Box } from '../../../lib/base';

export default function FiltersContainer({
  dateRangeFilter,
  otherFilters,
}: {
  readonly dateRangeFilter?: React.ReactNode;
  readonly otherFilters: React.ReactNode[];
}) {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        flexDirection: 'row',
        gap: 1,
        alignItems: { xs: 'flex-start', sm: 'center' },
      }}
    >
      {otherFilters.length > 0 && (
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            flexDirection: 'row',
            gap: 1,
            alignItems: { xs: 'flex-start', sm: 'center' },
          }}
        >
          {/* Keys are set in the parents. Mostly in makeFilters.tsx */}
          {otherFilters.map((filter) => filter)}
        </Box>
      )}
      {dateRangeFilter}
    </Box>
  );
}
